import { render, staticRenderFns } from "./menuSetting.vue?vue&type=template&id=5c333eda"
import script from "./menuSetting.vue?vue&type=script&lang=js"
export * from "./menuSetting.vue?vue&type=script&lang=js"
import style0 from "./menuSetting.vue?vue&type=style&index=0&id=5c333eda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports